export enum Balances {
  opening = "Opening",
  closing = "Closing",
}

export enum BalanceAlignmentDescription {
  Opening = "Opening Balance Alignment Transaction",
  Closing = "Closing Balance Alignment Transaction",
  Generated = "Generated Balance Alignment Transaction",
  Starting = "Starting Opening Balance",
}
